import { Button, Modal } from "antd";
import React from "react";

export function ConfirmPopup({
  confirmData,
  setConfirmData,
  okLoading,
  onOk,
  okText = "Ok",
  cancelText = "Cancel",
  content = "No content",
}) {
  return (
    <Modal
      className="campaign-stop-popup"
      closeIcon={false}
      open={confirmData.visible}
      footer={[
        <Button key="cancel" onClick={() => setConfirmData({ visible: false })}>
          {cancelText}
        </Button>,
        <Button danger key="ok" loading={okLoading} onClick={onOk} type="primary">
          {okText}
        </Button>,
      ]}
    >
      {content}
    </Modal>
  );
}
